// src/hooks/useBuyerPersonaQuiz.js
import { useState, useCallback } from 'react';
import { get, post, put } from '../helpers/apiHelper';

export const useBuyerPersonaQuiz = () => {
    const [result, setResult] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const getBuyerPersona = useCallback(async () => {
        setLoading(true);
        try {
            // Endpoint correcto según la documentación
            const response = await get('buyer-persona/result');
            if (response) {
                setResult(response);
                setError(null);
            } else {
                setResult(null);
            }
        } catch (error) {
            // Si es 404, significa que no tiene buyer persona, lo cual es un estado válido
            if (error.status === 404) {
                setResult(null);
                setError(null);
            } else {
                console.error('Error fetching buyer persona:', error);
                setError(error);
            }
        } finally {
            setLoading(false);
        }
    }, []);

    const createBuyerPersona = async (responses) => {
        setLoading(true);
        try {
            const response = await post('buyer-persona/quiz', { responses });
            if (response) {
                setResult(response);
                setError(null);
            }
            return response;
        } catch (error) {
            console.error('Error creating buyer persona:', error);
            setError(error);
            throw error;
        } finally {
            setLoading(false);
        }
    };

    const updateBuyerPersona = async (responses) => {
        setLoading(true);
        try {
            const response = await put('buyer-persona/quiz', { responses });
            if (response) {
                setResult(response);
                setError(null);
            }
            return response;
        } catch (error) {
            console.error('Error updating buyer persona:', error);
            setError(error);
            throw error;
        } finally {
            setLoading(false);
        }
    };

    return {
        result,
        loading,
        error,
        getBuyerPersona,
        createBuyerPersona,
        updateBuyerPersona
    };
};

export default useBuyerPersonaQuiz; 